module.exports = __webpack_public_path__ + "img/icon-close.d929d5f0.svg";